export { Paragraph, Paragraph2XS, ParagraphLG, ParagraphSM, ParagraphXL, ParagraphXS } from './Paragraph'
